import { useAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'
import { isBlank } from '@!/Util'
import { listIndexAtom, cardInfoAtom, apiTimeAtom, payTypeAtom } from '@!/atoms/paymentAtom'
import { PaymentSelect as PaymentSelectComponent } from '@!/User/Payment/components'
import { usePaymentValidation, useCoinPurchase } from '@!/User/Payment/Hooks'

export const PaymentSelect = () => {
  usePaymentValidation()

  const navigate = useNavigate()
  const [cardInfo] = useAtom(cardInfoAtom)
  const [, setPayType] = useAtom(payTypeAtom)

  const [listIndex] = useAtom(listIndexAtom)
  const [apiTime] = useAtom(apiTimeAtom)
  const { executePurchase, isPurchasing, isPurchaseError } = useCoinPurchase()

  const handlePurchase = (payType) => {
    setPayType(payType)

    executePurchase(payType, listIndex, apiTime)
  }

  const pageBack = (e) => {
    e.preventDefault()
    navigate(-1)
  }

  const handleDialog = () => {
    navigate(-1)
  }

  const creditCardLink = isBlank(cardInfo) ? '/new_card' : '/confirm'

  return (
    <>
      <PaymentSelectComponent pageBack={pageBack} creditCardLink={creditCardLink} handlePurchase={handlePurchase} />
      <CircularProgressModal isOpen={isPurchasing} />
      <ConfirmPopupModal handlePopup={() => handleDialog()} text="エラーが発生しました。" isOpen={!!isPurchaseError} />
    </>
  )
}

export default PaymentSelect
